import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const DescriptionSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default DescriptionSVG;
